import React, { useEffect } from "react";
import "./particles.css";
import AutoTyping, { BlinkCursor } from "react-auto-typing";
import colorlogo from "../../assets/logo/logo-ring.png";
import defaultImage from "../../assets/hero-black-background.jpg";

const Particles = ({ title = "", subTitle = "", page = "", image = "" }) => {
  useEffect(() => {
    if (window.particlesJS) {
      window.particlesJS("particles-js", {
        particles: {
          number: { value: 80, density: { enable: true, value_area: 800 } },
          color: { value: "#f3792c" },
          shape: {
            type: "circle",
            stroke: { width: 0, color: "#000000" },
            polygon: { nb_sides: 7 },
            image: { src: "img/github.svg", width: 100, height: 100 },
          },
          opacity: {
            value: 0.5,
            random: false,
            anim: { enable: false, speed: 1, opacity_min: 0.1, sync: false },
          },
          size: {
            value: 3,
            random: true,
            anim: { enable: false, speed: 40, size_min: 0.1, sync: false },
          },
          line_linked: {
            enable: true,
            distance: 150,
            color: "#f3792c",
            opacity: 0.4,
            width: 2,
          },
          move: {
            enable: true,
            speed: 4,
            direction: "none",
            random: true,
            straight: false,
            out_mode: "bounce",
            bounce: false,
            attract: { enable: false, rotateX: 600, rotateY: 1200 },
          },
        },
        interactivity: {
          detect_on: "canvas",
          events: {
            onhover: { enable: true, mode: "repulse" },
            onclick: { enable: true, mode: "push" },
            resize: true,
          },
          modes: {
            grab: { distance: 400, line_linked: { opacity: 1 } },
            bubble: {
              distance: 400,
              size: 40,
              duration: 2,
              opacity: 8,
              speed: 3,
            },
            repulse: { distance: 200, duration: 0.4 },
            push: { particles_nb: 4 },
            remove: { particles_nb: 2 },
          },
        },
        retina_detect: false,
      });
    }
  }, []);

  return (
    <>
      <div
        id="particles-js"
        className={
          page === "homepage"
            ? "particles-container homepage"
            : "particles-container"
        }
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${
            image ? image : defaultImage
          })`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center", // adjust as necessary
          backgroundSize: "cover",
        }}
      >
        <div
          className={
            page === "homepage" ? "title-container homepage" : "title-container"
          }
        >
          <div className="titles">
            {page === "homepage" && <img src={colorlogo} alt="logo" />}
            {title && (
              <h1 id="content-bg">
                <AutoTyping
                  active // <boolean>
                  textRef={title}
                  writeSpeed={1} // <number>
                  deleteSpeed={150} // <number>
                  delayToWrite={140} // <number>
                  delayToDelete={100000} // <number>
                />
              </h1>
            )}
            {subTitle && (
              <h2>
                {subTitle}
                {/* <AutoTyping
                  active // <boolean>
                  textRef={subTitle}
                  writeSpeed={1200} // <number>
                  deleteSpeed={150} // <number>
                  delayToWrite={140} // <number>
                  delayToDelete={100000} // <number>
                /> */}
              </h2>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Particles;
